module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4goCBx4eXODUOgAAAL9JREFUWMPlV7sOhDAMcxD0/7+3DGYAdCjQO0BNPFzHSpUd5+EU+NdDcgKAQU1kUEYPAKYETyfgwQFUU4IrFajSIpTUAMnJzGaSPN6Pae22gvs6iCXgyDA8Bace/0RdW2/GwDZrRt1VgTdRdyFwBXw36i5mtAMegZ+Cd1XAT7g0O94V2E6RTMKW0aSPYkekphN4QyLEjJ6kJMuOi8SO7ygRvg/8IpGykHwjoVrJSioBNy01O2ErFbKteFOlyL9mC9p1evvmOG02AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/tamgiac.png
// module id = 1235
// module chunks = 0